// Mirrors the backend enum com.trajectx.trajectory.ScoreAggregation. Kept in
// its own import-free module so DashboardTypes (which TrajectoryService
// imports) can use it without an import cycle through EffectiveScore.
export enum ScoreAggregation {
	// The newest snapshot that carries a score wins. Today's behaviour and the
	// default.
	LATEST = "LATEST",
	// The unweighted mean of every scored snapshot; the pie counts it at the
	// nearest level with ties rounded up, the legend averages it unrounded.
	AVERAGE = "AVERAGE"
}
